import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { ago, dt } from "./format";
import { C, Dot, Pill, Select } from "./ui";

export function Errors() {
  const [days, setDays] = useState("7");
  const groups = trpc.platform.errors.groups.useQuery({ days: Number(days) });
  const recent = trpc.platform.errors.recent.useQuery({ limit: 50 });

  return (
    <div className="pf-grid" style={{ gap: 22 }}>
      <div className="pf-row" style={{ flexWrap: "wrap" }}>
        <div>
          <h2 className="pf-title">Störungen</h2>
          <p className="pf-lead">Unerwartete Serverfehler aller Betriebe, nach Art zusammengefasst.</p>
        </div>
        <div style={{ flex: 1 }} />
        <div style={{ width: 190 }}>
          <Select value={days} onChange={(e) => setDays(e.target.value)} options={[{ value: "1", label: "Letzte 24 Stunden" }, { value: "7", label: "Letzte 7 Tage" }, { value: "30", label: "Letzte 30 Tage" }]} />
        </div>
      </div>

      <div className="pf-card pf-table-wrap">
        <h3 className="pf-h" style={{ padding: "10px 14px 0" }}>Nach Art</h3>
        <table className="pf-table">
          <thead><tr><th>Anzahl</th><th>Wo</th><th>Meldung</th><th className="num">Betriebe</th><th>Zuletzt</th></tr></thead>
          <tbody>
            {(groups.data ?? []).map((g, i) => (
              <tr key={i}>
                <td><Pill color={g.count > 10 ? C.red : C.amber}>{g.count}×</Pill></td>
                <td><code className="pf-mono" style={{ color: C.cyan, fontSize: 12 }}>{g.path}</code></td>
                <td style={{ maxWidth: 460, wordBreak: "break-word" }}>{g.message}</td>
                <td className="num pf-mono">{g.orgs || "—"}</td>
                <td style={{ color: "var(--pf-text-2)" }}>{ago(g.lastAt)}</td>
              </tr>
            ))}
            {!groups.isLoading && !groups.data?.length && (
              <tr><td colSpan={5} className="pf-empty"><span className="pf-row" style={{ justifyContent: "center" }}><Dot /> Keine Fehler in diesem Zeitraum.</span></td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pf-card pf-table-wrap">
        <h3 className="pf-h" style={{ padding: "10px 14px 0" }}>Letzte Einzelfälle</h3>
        <table className="pf-table">
          <thead><tr><th>Zeit</th><th>Betrieb</th><th>Wo</th><th>Meldung</th></tr></thead>
          <tbody>
            {(recent.data ?? []).map((e) => (
              <tr key={e.id}>
                <td className="pf-mono" style={{ color: "var(--pf-text-2)", whiteSpace: "nowrap", fontSize: 12 }}>{dt(e.at)}</td>
                <td>{e.org}</td>
                <td><code className="pf-mono" style={{ color: C.cyan, fontSize: 12 }}>{e.path}</code></td>
                <td style={{ maxWidth: 460, wordBreak: "break-word" }}>{e.message}</td>
              </tr>
            ))}
            {!recent.isLoading && !recent.data?.length && <tr><td colSpan={4} className="pf-empty">Keine Einträge.</td></tr>}
          </tbody>
        </table>
      </div>
      <p className="pf-muted" style={{ fontSize: 12, margin: 0 }}>
        Erfasst werden unerwartete Serverfehler ohne Eingabedaten; E-Mail-Adressen und Kontonummern werden unkenntlich gemacht. Einträge werden nach 30 Tagen gelöscht.
      </p>
    </div>
  );
}
